// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3QP0H","info":"UpdateTermsInfo_info__2gYFl"};